

























import {Component, Vue} from 'vue-property-decorator';
import formatStoreLabel from '@/filters/StoreLabelFormatter';
import formatStoreId from '@/filters/StoreIdFormatter';
import MenuBody from '@/components/MenuBody.vue';
import { StoreService } from '@/services/StoreService';
import { Inject } from 'vue-typedi';
import { Store } from '@/model/Store';
import authentication from '@/configuration/authentication';
import { PageName } from '@/configuration/pages';

@Component({
  filters: {formatStoreLabel, formatStoreId},
  components: {MenuBody}
})
export default class GlobalHeader extends Vue {

  @Inject()
  storeService!: StoreService;        

  isMenuDisplayed: boolean = false;
  allStores: Store[] = [];

  created() {
    this.getAllStores();
  }

  get storeLabel(): string {
    return sessionStorage.getItem("storeLabel");
  }

  get storeId(): string {
    return sessionStorage.getItem("storeId");
  }

  private getAllStores() {
    this.storeService.getStores().then(data => {
      this.allStores = data.stores 
      ? data.stores.filter(store => store.storeId != this.storeId) 
      : [];
    })
  }

  redirectToPage(page: PageName) {
    if (this.$router.currentRoute.name != page) {
      this.$router.push({ name: page.toString() })
                  .catch((e) => {
                    console.debug(e);
                    this.isMenuDisplayed = false;  
                  });
    }
    this.isMenuDisplayed = false;
  }

  onLogout() {
    authentication.logout();
  }
}
